import React from 'react';
import { Link, NavLink, useMatch } from 'react-router-dom';
import { GITA_LANGUAGES } from '../../config/languages';
import './GitaHeader.css';

export const GitaHeader = ({
  language = 'en',
  audio = 'male',
  onLanguageChange = () => {},
  onAudioChange = () => {},
  showReaderControls = true,
}) => {
  const readMatch = useMatch({ path: '/read/:chapter/:sloka', end: true });

  const groups = [...new Set(GITA_LANGUAGES.map((l) => l.group))];

  return (
    <header className="gita-header">
      <div className="gita-header__brand">
        <Link to="/read/1/1" className="gita-header__logo-block">
          <span className="gita-header__logo-title">The Gita</span>
          <span className="gita-header__logo-sub" lang="sa">
            भगवद्गीता
          </span>
        </Link>
        <p className="gita-header__tagline">Śrīmad Bhagavad Gītā — a free reader</p>
      </div>

      <nav className="gita-header__nav" aria-label="Site">
        <Link
          to="/read/1/1"
          className={`gita-nav-link${readMatch ? ' gita-nav-link--active' : ''}`}
          aria-current={readMatch ? 'page' : undefined}
        >
          Read
        </Link>
        <NavLink
          to="/about"
          className={({ isActive }) => `gita-nav-link${isActive ? ' gita-nav-link--active' : ''}`}
        >
          About
        </NavLink>
        <a
          className="gita-header__pill"
          href="https://api.thegita.org.in"
          target="_blank"
          rel="noopener noreferrer"
        >
          API
        </a>
        <a
          className="gita-header__pill"
          href="https://api.thegita.org.in"
          target="_blank"
          rel="noopener noreferrer"
        >
          GraphQL
        </a>
        <a
          className="gita-header__pill gita-header__pill--accent"
          href="https://ux.thegita.org.in"
          target="_blank"
          rel="noopener noreferrer"
          title="Optional study assistant — verify with the text and trusted sources"
        >
          AI Bot
        </a>
      </nav>

      {showReaderControls ? (
        <div className="gita-header__controls">
          <div className="gita-control">
            <label htmlFor="gita-language-select">Translation</label>
            <select
              id="gita-language-select"
              value={language}
              onChange={(e) => onLanguageChange(e.target.value)}
              aria-label="Translation language"
              className="gita-select"
            >
              {groups.map((g) => (
                <optgroup key={g} label={g}>
                  {GITA_LANGUAGES.filter((l) => l.group === g).map((l) => (
                    <option key={l.code} value={l.code}>
                      {l.label}
                    </option>
                  ))}
                </optgroup>
              ))}
            </select>
          </div>
          <div className="gita-control">
            <label htmlFor="gita-audio-select">Recitation</label>
            <select
              id="gita-audio-select"
              value={audio}
              onChange={(e) => onAudioChange(e.target.value)}
              aria-label="Narration voice"
              className="gita-select"
            >
              <option value="male">Male voice</option>
              <option value="female">Female voice</option>
            </select>
          </div>
        </div>
      ) : null}
    </header>
  );
};
